import movieReducer from "./movieReducer";
import { combineReducers } from "redux";
import genreReducer from "./genreReducer";

const rootReducer = combineReducers({
  movies: movieReducer,
  genres: genreReducer,
});

export default rootReducer;
